var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4286 12.5714C21.2965 12.5714 22 13.275 22 14.1429V18.8571C22 20.5929 20.5929 22 18.8571 22H3.14286C1.4071 22 0 20.5929 0 18.8571V14.1429C0 13.275 0.70356 12.5714 1.57143 12.5714C2.4393 12.5714 3.14286 13.275 3.14286 14.1429V18.8571H18.8571V14.1429C18.8571 13.275 19.5607 12.5714 20.4286 12.5714ZM11 0C11.8679 0 12.5714 0.70356 12.5714 1.57143V8.77767L14.6031 6.74597C15.2168 6.1323 16.2118 6.1323 16.8254 6.74597C17.4391 7.35966 17.4391 8.35463 16.8254 8.96832L11 14.7937L5.17454 8.96832C4.56087 8.35463 4.56087 7.35966 5.17454 6.74597C5.78823 6.1323 6.7832 6.1323 7.39689 6.74597L9.42857 8.77767V1.57143C9.42857 0.70356 10.1321 0 11 0Z",
    fill: "#8B8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.ce53eea45de191f05a56770bbc3780d2.svg";
export { ForwardRef as ReactComponent };